import emailService from '../../api/emailService.js';
import { formatISTDateTime } from './formatUtils';

export default function EmailHistoryModal({
  order,
  onClose,
  buildOrderEmailDetails,
  resendingEmailKey,
  onResendFailed,
}) {
  if (!order) return null;

  return (
    <div className="modal-overlay">
      <div className="dispute-modal email-history-modal">
        <div className="modal-header">
          <div>
            <h3>Email History — {order.name}</h3>
            <p>{order.email}</p>
          </div>
          <button type="button" className="close-btn" onClick={onClose}>Close</button>
        </div>
        <div className="modal-content">
          {order._loading ? (
            <p className="email-history-loading">Loading email history…</p>
          ) : !Array.isArray(order.email_logs) || order.email_logs.length === 0 ? (
            <div className="no-orders"><p>No email logs found for this order.</p></div>
          ) : (
            <div className="email-history-list">
              {order.email_logs.map((log, idx) => (
                <div className="email-history-item" key={`${log.created_at || idx}-${idx}`}>
                  <div className="email-history-top">
                    <span className={`status-badge email-log-status ${log.sent_status || 'pending'}`}>
                      {(log.sent_status || 'pending').toUpperCase()}
                    </span>
                    <span className="email-history-time">IST: {formatISTDateTime(log.created_at)}</span>
                  </div>
                  <div className="email-history-line"><strong>To:</strong> {log.recipient_email || order.email || '—'}</div>
                  <div className="email-history-line"><strong>Type / Status:</strong> {log.email_type || 'status_update'} / {log.status || '—'}</div>
                  <div className="email-history-line"><strong>Subject:</strong> {log.subject || '—'}</div>
                  <details className="email-content-preview">
                    <summary>Show email content</summary>
                    <pre>
                      {emailService.buildStatusEmailContent(
                        log.status || order.custom_status,
                        buildOrderEmailDetails(order),
                        order.tracking_number || '',
                      ).text}
                    </pre>
                  </details>
                  {log.error_message ? (
                    <div className="email-history-line email-error-line"><strong>Error:</strong> {log.error_message}</div>
                  ) : null}
                  {log.message_id ? (
                    <div className="email-history-line"><strong>Message ID:</strong> {log.message_id}</div>
                  ) : null}
                  {String(log.sent_status).toLowerCase() === 'failed' && (
                    <div className="email-history-actions">
                      <button
                        type="button"
                        className="btn retry-btn"
                        disabled={resendingEmailKey === `${order.id}-${idx}-${log.created_at || ''}`}
                        onClick={() => onResendFailed(order, log, idx)}
                      >
                        {resendingEmailKey === `${order.id}-${idx}-${log.created_at || ''}` ? 'Resending...' : 'Resend'}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
